import { UserPlus, ClipboardList, MapPin, Clock, UserCheck } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Heading } from "@/components/design-system/Heading";
import { motion } from "framer-motion";

const benefits = [
  {
    icon: UserPlus,
    title: "Crea el perfil del teu equip",
    description: "Comença creant el perfil del teu equip"
  },
  {
    icon: ClipboardList,
    title: "Publica els detalls del partit",
    description: "Comparteix tots els detalls importants del partit"
  },
  {
    icon: MapPin,
    title: "Estableix la ubicació",
    description: "Especifica on es jugarà el partit"
  },
  {
    icon: Clock,
    title: "Espera les sol·licituds",
    description: "Els porters aplicaran al teu partit"
  },
  {
    icon: UserCheck,
    title: "Tria el teu porter",
    description: "Selecciona el porter perfecte per al teu partit"
  }
];

export const TeamBenefitsCa = () => {
  return (
    <div>
      <Heading level="h2" className="text-2xl font-bold mb-6 text-center">
        Per a Equips ⚽
      </Heading>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {benefits.map((benefit, index) => (
          <motion.div
            key={benefit.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="h-full"
          >
            <Card className="p-6 h-full bg-white/60 backdrop-blur border-2 border-primary/10 hover:border-primary/20 transition-all duration-300 flex flex-col">
              <div className="mb-4 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <benefit.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-600 flex-grow">{benefit.description}</p>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};